import { Box } from '@chakra-ui/react';
import FieldError from 'components/common/FieldError';

export type ErrorsProps = {
  errors: string[];
};

const Errors = ({ errors }: ErrorsProps) => {
  const renderErrors = errors.map((error) => <FieldError key={error} error={error} />);

  return <Box>{renderErrors}</Box>;
};

export { Errors };
